export const UPDATE_STATE = "UPDATE_STATE";
export const RESET_STATE = "RESET_STATE";

export const update_state = () => {
  return {
    type: UPDATE_STATE,
  };
};

export const reset_state = () => {
  return {
    type: RESET_STATE,
  };
};

export const updateState = () => {
  return (dispatch) => {
    dispatch(update_state());
  };
};

export const resetState = () => {
  return (dispatch) => {
    dispatch(reset_state());
  };
};
